import { render, staticRenderFns } from "./assessmentVersionDetail.vue?vue&type=template&id=a290a422&scoped=true&"
import script from "./assessmentVersionDetail.vue?vue&type=script&lang=js&"
export * from "./assessmentVersionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a290a422",
  null
  
)

export default component.exports